import { RefObject, useCallback } from 'react';

import { DEFAULT_MONTHS_COUNT } from '@calendar/calendarHelpers';
import useHandleMonthChange from '@calendar/hooks/useHandleMonthChange';
import useMonthsToRenderStore from '@calendar/store/useMonthsToRenderStore';
import Button from '@ui/components/Button';
import { formatCsMonth } from '@utils/formatCs';

import MonthNavigationButton from './MonthNavigationButton';

interface MonthSelectorProps {
  monthListRef: RefObject<HTMLDivElement>;
}

const MonthSelector = ({ monthListRef }: MonthSelectorProps) => {
  const handleMonthChange = useHandleMonthChange();

  const { selectedMonth } = useMonthsToRenderStore();
  const { month, index } = selectedMonth;

  const handleActualMonth = useCallback(() => {
    handleMonthChange(0, true, monthListRef);
  }, [handleMonthChange, monthListRef]);

  const handlePrevMonth = useCallback(() => {
    handleMonthChange(index === 0 ? 0 : index - 1, true, monthListRef);
  }, [handleMonthChange, index, monthListRef]);

  const handleNextMonth = useCallback(() => {
    handleMonthChange(
      index >= DEFAULT_MONTHS_COUNT ? DEFAULT_MONTHS_COUNT - 1 : index + 1,
      true,
      monthListRef,
    );
  }, [handleMonthChange, index, monthListRef]);

  const isPrevMonthDisabled = index === 0;
  const isNextMonthDisabled = index === DEFAULT_MONTHS_COUNT;

  return (
    <>
      <div className="ml-6 mr-4 flex w-[230px] flex-row items-center justify-between">
        <MonthNavigationButton
          direction="prev"
          onClick={handlePrevMonth}
          disabled={isPrevMonthDisabled}
        />
        <h3 className="mx-auto font-montserrat text-[24px]/[34px] font-semibold text-brand-gray-100">
          {formatCsMonth(month)}
        </h3>
        <MonthNavigationButton
          direction="next"
          onClick={handleNextMonth}
          disabled={isNextMonthDisabled}
        />
      </div>
      <Button
        onClick={handleActualMonth}
        classNameWrapper="ml-auto lg:ml-8 mr-4 lg:mr-0"
      >
        Dnes
      </Button>
    </>
  );
};

export default MonthSelector;
